export default __webpack_public_path__ + "static/media/ios-arrow-back.5c8b3d2482c962fdf0d444715657499a.svg";